import "../services.css"
import "../servicescovers.css"
import "../servicesflextion.css"

import { useState, useRef, useEffect } from "react";
import { HelmetProvider } from 'react-helmet-async';
import R from "../../../assets/Images/Quote/Hero-Section.jpg"

import Arrow from "../../../assets/Images/Elements/Arrow_O1.svg"

import Header from "../../../assets/components/01_header/header"
import Footer from "../../../assets/components/02_footer/footer"
import QuotationComponent from "../../../assets/components/06_quotation_component/quotation_component"

import test from "../../../assets/Images/Elements/M-Orange.svg"

export default function WbsiteDevelopment() {
    const [stepT, setStepT] = useState(1);
    const TOTAL_SLIDES = 8;

    const selectorRef = useRef(null);
    const itemRefs = useRef([]);

    const autoSlideRef = useRef(null);
    const pauseTimeoutRef = useRef(null);

    const scrollToItem = (index) => {
        const item = itemRefs.current[index];
        const container = selectorRef.current;

        if (!item || !container) return;

        const itemLeft = item.offsetLeft;
        const containerWidth = container.offsetWidth;
        const itemWidth = item.offsetWidth;

        container.scrollTo({
            left: itemLeft - containerWidth / 2 + itemWidth / 2,
            behavior: "smooth",
        });
    };

    useEffect(() => {
        startAutoSlide();
        return stopAutoSlide;
    }, []);

    const startAutoSlide = () => {
        stopAutoSlide();
        autoSlideRef.current = setInterval(() => {
            setStepT(prev => (prev === TOTAL_SLIDES ? 1 : prev + 1));
        }, 5000);
    };

    const stopAutoSlide = () => {
        if (autoSlideRef.current) {
            clearInterval(autoSlideRef.current);
            autoSlideRef.current = null;
        }
    };

    const pauseAutoSlide = () => {
        stopAutoSlide();

        if (pauseTimeoutRef.current) {
            clearTimeout(pauseTimeoutRef.current);
        }

        pauseTimeoutRef.current = setTimeout(() => {
            startAutoSlide();
        }, 4000);
    };

    useEffect(() => {
        scrollToItem(stepT - 1);
    }, [stepT]);

    return (
        <div>
            <HelmetProvider>
                <title>Expert Website Design Solutions for Brands in Mumbai</title>
                <meta name="Adstrate is a digital marketing agency in Mumbai providing website design & development, social media marketing in Mumbai, Instagram marketing agency, and content creation services for business growth." />
                <link rel="canonical" href="https://adstrate.in/services/website-design-and-development" />
            </HelmetProvider>
            <Header />
            <div className="ServicesDetails-HeroSection ServicesDetails-HeroSection-Website">
                <div className="ServicesDetails-HeroSection-Glass">
                    <h1>Comprehensive Website Design & Development Services</h1>
                    <p>As a top digital marketing agency in Mumbai, Adstrate offers end-to-end website design and development services that combine creative design, responsive UX/UI, and technical excellence.</p>
                    <a href="/quotation">
                        <p className="LinkLabel">Get Quote</p>
                        <img src={Arrow}/>
                    </a>
                </div>
            </div>
            <div className="ServicesPages-Services-Main">
                <div className="ServicesPages-Services-Info">
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 1 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Discovery & Requirement Gathering</h2>
                            <p>
                                Understand business objectives, target audience, competitors, and functional requirements.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 2 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Wireframing & Sitemap Planning</h2>
                            <p>
                                Define website structure, navigation, and user flow for optimal usability. 
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 3 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>UI/UX Design Execution</h2>
                            <p>
                                Create responsive, mobile-first, and conversion-oriented layouts aligned with brand identity.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 4 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Development & CMS Setup</h2>
                            <p>
                                Implement clean code, WordPress or Shopify configuration, and security best practices.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 5 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>SEO & Performance Optimization</h2>
                            <p>
                                Ensure website is SEO-friendly, fast-loading, and optimized for search engines.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 6 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Quality Assurance & Testing</h2>
                            <p>
                                Conduct cross-browser, device responsiveness, and performance checks with revision rounds.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 7 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Launch & Analytics Integration</h2>
                            <p>
                               Deploy the website, integrate analytics, and provide handover documentation.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 8 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Training & Offboarding Support</h2>
                            <p>
                                Offer basic training, offboarding support, and recommendations for ongoing maintenance.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ServicesPages-Services-Selector" ref={selectorRef}>
                    <div className="ServicesPages-Services-Selector-Selection">
                        {[
                        "Discovery & Requirement Gathering",
                        "Wireframing & Sitemap Planning",
                        "UI/UX Design Execution",
                        "Development & CMS Setup",
                        "SEO & Performance Optimization",
                        "Quality Assurance & Testing",
                        "Launch & Analytics Integration",
                        "Training & Offboarding Support",

                        ].map((text, index) => (
                        <div
                            key={index}
                            ref={(el) => (itemRefs.current[index] = el)}
                            className={stepT === index + 1 ? "ServicesPages-Services-Selector-Card Home-active MicroLinksText" : "ServicesPages-Services-Selector-Card"}
                            onClick={() => {
                                pauseAutoSlide();
                                setStepT(index + 1);
                                scrollToItem(index);
                            }}
                        >
                            <div className="ServicesPages-Services-Selector-selection"></div>
                            <div className="ServicesPages-Services-Selector-hover"></div>
                            <p>{text}</p>
                        </div>
                        ))}
                    </div>
                </div>
            </div>
            <QuotationComponent />
            <Footer />
        </div>
    );
}